"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1791],{

/***/ 28058:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "q": function() { return /* binding */ Shimmer; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@wartek-id/shimmer/node_modules/clsx/dist/clsx.m.js
function r(e){var t,f,n="";if("string"==typeof e||"number"==typeof e)n+=e;else if("object"==typeof e)if(Array.isArray(e))for(t=0;t<e.length;t++)e[t]&&(f=r(e[t]))&&(n&&(n+=" "),n+=f);else for(t in e)e[t]&&(n&&(n+=" "),n+=t);return n}function clsx(){for(var e,t,f=0,n="";f<arguments.length;)(e=arguments[f++])&&(t=r(e))&&(n&&(n+=" "),n+=t);return n}/* harmony default export */ var clsx_m = (clsx);
;// CONCATENATED MODULE: ./node_modules/@wartek-id/shimmer/dist/index.esm.js



/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') {
    return;
  }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ".Shimmer-module_shimmer__3pOKa{animation:Shimmer-module_a-background-move__3AzYv 1.5s infinite;background-image:linear-gradient(90deg,#f7f7f7,#dcdcdc,#f7f7f7);background-size:200%;border-radius:var(--size-border-radius-base)}.Shimmer-module_shimmer__3pOKa.Shimmer-module_rounded__3tSiD{border-radius:50%}@keyframes Shimmer-module_a-background-move__3AzYv{0%{background-position:100%}to{background-position:-100%}}";
var styles = {"shimmer":"Shimmer-module_shimmer__3pOKa","a-background-move":"Shimmer-module_a-background-move__3AzYv","rounded":"Shimmer-module_rounded__3tSiD","aBackgroundMove":"Shimmer-module_a-background-move__3AzYv"};
styleInject(css_248z);

var Shimmer = react.forwardRef(function (_a, ref) {
    var _b = _a.height, height = _b === void 0 ? 16 : _b, _c = _a.width, width = _c === void 0 ? 100 : _c, rounded = _a.rounded, style = _a.style, className = _a.className, _d = _a.noOfLines, noOfLines = _d === void 0 ? 1 : _d, props = __rest(_a, ["height", "width", "rounded", "style", "className", "noOfLines"]);
    var classes = clsx_m(styles.shimmer, rounded && styles.rounded, className);
    var lines = new Array(noOfLines).fill('');
    return (react.createElement(react.Fragment, null, lines.map(function (_line, idx) { return (react.createElement("div", __assign({ className: classes, style: Object.assign({}, { width: width, height: height }, __assign({}, style)) }, props, { ref: ref, key: idx }))); })));
});




/***/ }),

/***/ 14644:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cz": function() { return /* binding */ useGetTopicAksiNyataSession; },
/* harmony export */   "Ht": function() { return /* binding */ useTriggerGenerateCertificatePdf; },
/* harmony export */   "Lr": function() { return /* binding */ useTopicProgress; },
/* harmony export */   "MD": function() { return /* binding */ useTopicNewest; },
/* harmony export */   "Sw": function() { return /* binding */ useGetTopicDetail; },
/* harmony export */   "TA": function() { return /* binding */ useGetRelevanceTopic; },
/* harmony export */   "Ti": function() { return /* binding */ usePostAksiNyataAppeal; },
/* harmony export */   "W0": function() { return /* binding */ usePostAksiNyata; },
/* harmony export */   "XI": function() { return /* binding */ useGetTopicList; },
/* harmony export */   "YK": function() { return /* binding */ usePostTopicCertificate; },
/* harmony export */   "bJ": function() { return /* binding */ useGetCertificate; },
/* harmony export */   "bt": function() { return /* binding */ useGetAksiNyataRevision; },
/* harmony export */   "gb": function() { return /* binding */ useGetTopicAksiNyataOptions; },
/* harmony export */   "l4": function() { return /* binding */ usePostCertificate; },
/* harmony export */   "nL": function() { return /* binding */ useTopicCertificate; },
/* harmony export */   "oq": function() { return /* binding */ useTopicRecommendation; },
/* harmony export */   "w3": function() { return /* binding */ JenjangUnmatched; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28668);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25171);
/* harmony import */ var utils_api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71529);
/* harmony import */ var utils_customError__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97512);






var JenjangUnmatched = /*#__PURE__*/ function(CustomError) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(JenjangUnmatched, CustomError);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(JenjangUnmatched);
    function JenjangUnmatched(apiPath, originalError) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, JenjangUnmatched);
        var title = "Jenjang tidak sesuai";
        var description = "Topik yang anda akses tidak sesuai dengan jenjang akun anda.";
        return _super.call(this, {
            title: title,
            description: description,
            apiPath: apiPath,
            originalError: originalError
        });
    }
    return JenjangUnmatched;
}(utils_customError__WEBPACK_IMPORTED_MODULE_4__/* .CustomError */ .sH);
function useGetTopicList() {
    return (0,utils_api__WEBPACK_IMPORTED_MODULE_0__/* .useQueryApi */ .Zy)("/microlearnings/topics", {
        errorHandlerFn: function(status, path, error) {
            (0,utils_api__WEBPACK_IMPORTED_MODULE_0__/* .handleCommonErrors */ .CI)(status !== null && status !== void 0 ? status : 500, path, error);
        }
    });
}
function useGetTopicDetail(topicId) {
    return (0,utils_api__WEBPACK_IMPORTED_MODULE_0__/* .useQueryApi */ .Zy)("/microlearnings/topics/".concat(topicId), {
        queryConfig: {
            enabled: !!topicId
        },
        errorHandlerFn: function(status, path, error, errorResponse) {
            var ref, ref1, ref2, ref3;
            if (status === 400 && !!((ref1 = (ref = errorResponse.data) === null || ref === void 0 ? void 0 : ref.errors[0]) === null || ref1 === void 0 ? void 0 : ref1.code) && ((ref3 = (ref2 = errorResponse.data) === null || ref2 === void 0 ? void 0 : ref2.errors[0]) === null || ref3 === void 0 ? void 0 : ref3.code) === "08-118") {
                throw new JenjangUnmatched(path, error);
            } else {
                (0,utils_api__WEBPACK_IMPORTED_MODULE_0__/* .handleCommonErrors */ .CI)(status !== null && status !== void 0 ? status : 500, path, error);
            }
        }
    });
}
function useGetTopicAksiNyataOptions(topicId, enabled) {
    return (0,utils_api__WEBPACK_IMPORTED_MODULE_0__/* .useQueryApi */ .Zy)("/microlearnings/topics/".concat(topicId, "/aksi-nyata-options"), {
        queryConfig: {
            enabled: !!topicId && enabled
        }
    });
}
function useGetTopicAksiNyataSession(topicId, enabled) {
    var data = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return (0,utils_api__WEBPACK_IMPORTED_MODULE_0__/* .useQueryApi */ .Zy)("/microlearnings/topics/".concat(topicId, "/aksi-nyata"), {
        queryConfig: {
            enabled: !!topicId && enabled,
            useErrorBoundary: false
        },
        axiosConfig: {
            data: data
        }
    });
}
function usePostAksiNyata(topicId, method, opts) {
    return (0,utils_api__WEBPACK_IMPORTED_MODULE_0__/* .useMutationApi */ .fy)("/microlearnings/topics/".concat(topicId, "/aksi-nyata"), {
        mutationConfig: opts,
        axiosConfig: {
            method: method
        }
    });
}
function useGetRelevanceTopic(topicId) {
    return (0,utils_api__WEBPACK_IMPORTED_MODULE_0__/* .useQueryApi */ .Zy)("/microlearnings/topics/".concat(topicId, "/relevances"), {
        queryConfig: {
            useErrorBoundary: false
        }
    });
}
function useGetAksiNyataRevision(topicId, enabled) {
    return (0,utils_api__WEBPACK_IMPORTED_MODULE_0__/* .useQueryApi */ .Zy)("/microlearnings/topics/".concat(topicId, "/aksi-nyata/revision"), {
        queryConfig: {
            enabled: !!topicId && enabled,
            useErrorBoundary: false
        }
    });
}
function usePostCertificate(topicId, method, opts) {
    return (0,utils_api__WEBPACK_IMPORTED_MODULE_0__/* .useMutationApi */ .fy)("/microlearnings/topics/".concat(topicId, "/certificate"), {
        mutationConfig: opts,
        axiosConfig: {
            method: method
        }
    });
}
function useGetCertificate(param) {
    var enabled = param.enabled, errorHandler = param.errorHandler, refetchInterval = param.refetchInterval, topicId = param.topicId;
    return (0,utils_api__WEBPACK_IMPORTED_MODULE_0__/* .useQueryApi */ .Zy)("/microlearnings/topics/".concat(topicId, "/certificate"), {
        axiosConfig: {
            method: "GET"
        },
        queryConfig: {
            enabled: !!topicId && enabled,
            useErrorBoundary: false,
            refetchInterval: refetchInterval
        },
        errorHandlerFn: function(_status, _path, error, errorResponse) {
            var errorCode = errorResponse.data.errors[0].code;
            errorHandler === null || errorHandler === void 0 ? void 0 : errorHandler(errorCode, error);
        }
    });
}
function useTriggerGenerateCertificatePdf(topicId, opts) {
    return (0,utils_api__WEBPACK_IMPORTED_MODULE_0__/* .useMutationApi */ .fy)("/microlearnings/topics/".concat(topicId, "/certificate/rerender"), {
        mutationConfig: opts,
        axiosConfig: {
            method: "POST"
        }
    });
}
function usePostAksiNyataAppeal(topicId, opts) {
    return (0,utils_api__WEBPACK_IMPORTED_MODULE_0__/* .useMutationApi */ .fy)("/microlearnings/topics/".concat(topicId, "/aksi-nyata/appeal"), {
        mutationConfig: opts,
        axiosConfig: {
            method: "POST"
        }
    });
}
function useTopicNewest() {
    return (0,utils_api__WEBPACK_IMPORTED_MODULE_0__/* .useQueryApi */ .Zy)("/microlearnings/topic-recommendation", {
        queryConfig: {
            useErrorBoundary: false
        }
    });
}
function useTopicRecommendation() {
    return (0,utils_api__WEBPACK_IMPORTED_MODULE_0__/* .useQueryApi */ .Zy)("/microlearnings/section-page", {
        queryConfig: {
            useErrorBoundary: false
        }
    });
}
function useTopicProgress() {
    return (0,utils_api__WEBPACK_IMPORTED_MODULE_0__/* .useQueryApi */ .Zy)("/microlearnings/topics/progress", {
        queryConfig: {
            useErrorBoundary: false
        }
    });
}
function useTopicCertificate(param) {
    var topicId = param.topicId, errorHandler = param.errorHandler;
    return (0,utils_api__WEBPACK_IMPORTED_MODULE_0__/* .useQueryApi */ .Zy)("/microlearnings/topics/".concat(topicId, "/surat-selesai-belajar"), {
        queryConfig: {
            enabled: !!topicId,
            useErrorBoundary: false
        },
        errorHandlerFn: function(_status, _path, error, errorResponse) {
            var errorCode = errorResponse.data.errors[0].code;
            errorHandler === null || errorHandler === void 0 ? void 0 : errorHandler(errorCode, error);
        }
    });
}
function usePostTopicCertificate(topicId, opts) {
    return (0,utils_api__WEBPACK_IMPORTED_MODULE_0__/* .useMutationApi */ .fy)("/microlearnings/topics/".concat(topicId, "/surat-selesai-belajar"), {
        mutationConfig: opts,
        axiosConfig: {
            method: "POST"
        }
    });
}


/***/ }),

/***/ 26311:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(29815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98743);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var dayjs_plugin_timezone__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(34646);
/* harmony import */ var dayjs_plugin_timezone__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_timezone__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var dayjs_plugin_utc__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(97046);
/* harmony import */ var dayjs_plugin_utc__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_utc__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var dayjs_locale_id__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(23260);
/* harmony import */ var dayjs_locale_id__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(dayjs_locale_id__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _wartek_id_text__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(89004);
/* harmony import */ var api_microlearning_useAPIKeyValue__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(42979);
/* harmony import */ var _partials_Webinar_WebinarCard__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(9368);
/* harmony import */ var components_EmptyState__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(99270);
/* harmony import */ var _utils_webinar__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(83682);
/* harmony import */ var api_microlearning_useAPITopics__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(14644);
/* harmony import */ var hooks_useSafeRouter__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(28873);
/* provided dependency */ var process = __webpack_require__(34155);

















dayjs__WEBPACK_IMPORTED_MODULE_2___default().extend((dayjs_plugin_utc__WEBPACK_IMPORTED_MODULE_5___default()));
dayjs__WEBPACK_IMPORTED_MODULE_2___default().extend((dayjs_plugin_timezone__WEBPACK_IMPORTED_MODULE_3___default()));
dayjs__WEBPACK_IMPORTED_MODULE_2___default().locale("id");
var minutesBefore = 30;
var WebinarList = function(param) {
    var _isDesktop = param.isDesktop, isDesktop = _isDesktop === void 0 ? false : _isDesktop, _currentId = param.currentId, currentId = _currentId === void 0 ? "" : _currentId;
    var ref = (0,api_microlearning_useAPIKeyValue__WEBPACK_IMPORTED_MODULE_8__/* .useGetKeyPairValue */ .q8)(api_microlearning_useAPIKeyValue__WEBPACK_IMPORTED_MODULE_8__/* .MILKvKeys.WebinarEntries */ .QK.WebinarEntries), data = ref.data, status = ref.status;
    var ref1 = (0,api_microlearning_useAPITopics__WEBPACK_IMPORTED_MODULE_11__/* .useGetTopicList */ .XI)(), topics = ref1.data;
    var webinarListRef = react__WEBPACK_IMPORTED_MODULE_1__.useRef(null);
    var wibTime = dayjs__WEBPACK_IMPORTED_MODULE_2___default()().tz("Asia/Jakarta");
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_6__.useRouter)();
    var safeReplace = (0,hooks_useSafeRouter__WEBPACK_IMPORTED_MODULE_12__/* .useSafeRouter */ ._)().safeReplace;
    var RenderWebinarList = function() {
        var ref, ref1, ref2;
        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "px-4 pt-4",
            ref: webinarListRef,
            children: [
                status === "loading" && (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(Array(4)).map(function(_arr, index) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "mb-4",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_partials_Webinar_WebinarCard__WEBPACK_IMPORTED_MODULE_9__/* .WebinarPreloader */ .a, {})
                    }, "webinar-preloader-".concat(index));
                }),
                status === "success" && !!(data === null || data === void 0 ? void 0 : (ref = data.data) === null || ref === void 0 ? void 0 : ref.webinar) && data.data.webinar.map(function(param) {
                    var id = param.id, title = param.title, topic = param.topic, speakers = param.speakers, startDate = param.startDate, endDate = param.endDate, module = param.module;
                    var topicData = (0,_utils_webinar__WEBPACK_IMPORTED_MODULE_14__/* .getWebinarTopicData */ .Y)({
                        topikId: topic === null || topic === void 0 ? void 0 : topic.id,
                        topikTitle: topic === null || topic === void 0 ? void 0 : topic.title
                    }, ((topics === null || topics === void 0 ? void 0 : topics.data) || []).map(function(param) {
                        var id = param.id;
                        return +id;
                    }), module);
                    if (wibTime.isBefore(dayjs__WEBPACK_IMPORTED_MODULE_2___default()(endDate).add(minutesBefore, "minute"))) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "mb-4",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_partials_Webinar_WebinarCard__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                id: id,
                                href: "/".concat(process.env.NEXT_PUBLIC_TEMP_PELATIHAN_MANDIRI_PATH || "pelatihan-mandiri", "/webinar/").concat(id),
                                topicId: "".concat(topicData === null || topicData === void 0 ? void 0 : topicData.topikId),
                                topicName: topicData === null || topicData === void 0 ? void 0 : topicData.topikTitle,
                                title: title,
                                speakers: speakers,
                                startDate: startDate,
                                endDate: endDate,
                                active: currentId === id
                            })
                        }, "webinar-card-".concat(id));
                    }
                    return null;
                }),
                status === "success" && ((ref1 = data.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.webinar) === null || ref2 === void 0 ? void 0 : ref2.filter(function(param) {
                    var endDate = param.endDate;
                    return wibTime.isBefore(dayjs__WEBPACK_IMPORTED_MODULE_2___default()(endDate).add(minutesBefore, "minute"));
                })) <= 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_EmptyState__WEBPACK_IMPORTED_MODULE_10__/* .EmptyState */ .ub, {
                    title: "Tidak ada Webinar",
                    description: "Belum ada Webinar yang akan berlangsung untuk saat ini, silakan coba akses halaman ini lagi di lain waktu",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_EmptyState__WEBPACK_IMPORTED_MODULE_10__/* .EmptyStateAction */ .Px, {
                        onClick: function() {
                            return router.back();
                        },
                        children: "Kembali"
                    })
                })
            ]
        });
    };
    if (isDesktop) {
        if (!currentId) {
            var ref2;
            var firstWebinarChildInRef = (ref2 = webinarListRef.current) === null || ref2 === void 0 ? void 0 : ref2.children[0];
            if (currentId === "" && firstWebinarChildInRef) {
                var ref3;
                // find and get href in a tag
                var firstWebinarChildHref = (ref3 = firstWebinarChildInRef.querySelector("a")) === null || ref3 === void 0 ? void 0 : ref3.getAttribute("href");
                if (firstWebinarChildHref) {
                    safeReplace(firstWebinarChildHref);
                }
            }
        }
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_4___default()), {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: "Daftar Webinar"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "mt-[80px]",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_wartek_id_text__WEBPACK_IMPORTED_MODULE_15__/* .Text */ .x, {
                            variant: "display-sm",
                            className: "p-4",
                            children: "Daftar Webinar"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(RenderWebinarList, {})
                    ]
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_4___default()), {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                    children: "Daftar Webinar"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "overflow-y-auto",
                style: {
                    height: "calc(100vh - 3.5rem)"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(RenderWebinarList, {})
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (WebinarList);


/***/ }),

/***/ 9368:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ WebinarPreloader; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98743);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var dayjs_plugin_utc__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97046);
/* harmony import */ var dayjs_plugin_utc__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_utc__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var dayjs_plugin_timezone__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34646);
/* harmony import */ var dayjs_plugin_timezone__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_timezone__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var dayjs_locale_id__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(23260);
/* harmony import */ var dayjs_locale_id__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(dayjs_locale_id__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(86010);
/* harmony import */ var _wartek_id_text__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(89004);
/* harmony import */ var _wartek_id_shimmer__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(28058);
/* harmony import */ var _wartek_id_avatar__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(42586);
/* harmony import */ var utils_googleAnalytics__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7379);
/* harmony import */ var components_Anchor__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(55231);
/* harmony import */ var app_PelatihanMandiriPage_helper__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(30469);
/* provided dependency */ var process = __webpack_require__(34155);














dayjs__WEBPACK_IMPORTED_MODULE_2___default().extend((dayjs_plugin_utc__WEBPACK_IMPORTED_MODULE_3___default()));
dayjs__WEBPACK_IMPORTED_MODULE_2___default().extend((dayjs_plugin_timezone__WEBPACK_IMPORTED_MODULE_4___default()));
dayjs__WEBPACK_IMPORTED_MODULE_2___default().locale("id");
var WebinarPreloader = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "relative rounded border border-subdued bg-white px-4 py-3",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_wartek_id_shimmer__WEBPACK_IMPORTED_MODULE_10__/* .Shimmer */ .q, {
                className: "mb-2",
                height: 14,
                style: {
                    width: "50%"
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_wartek_id_shimmer__WEBPACK_IMPORTED_MODULE_10__/* .Shimmer */ .q, {
                className: "mb-4",
                height: 16,
                style: {
                    width: "100%"
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_wartek_id_shimmer__WEBPACK_IMPORTED_MODULE_10__/* .Shimmer */ .q, {
                className: "mb-4",
                height: 14,
                style: {
                    width: "100%"
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex justify-between",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_wartek_id_shimmer__WEBPACK_IMPORTED_MODULE_10__/* .Shimmer */ .q, {
                        className: "mb-4",
                        height: 14,
                        style: {
                            width: "30%"
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_wartek_id_shimmer__WEBPACK_IMPORTED_MODULE_10__/* .Shimmer */ .q, {
                        className: "mb-4",
                        height: 14,
                        width: 100
                    })
                ]
            })
        ]
    });
};
var WebinarCard = function(param) {
    var id = param.id, href = param.href, topicName = param.topicName, topicId = param.topicId, title = param.title, speakers = param.speakers, startDate = param.startDate, endDate = param.endDate, _active = param.active, active = _active === void 0 ? false : _active, _isShowNameSpeakers = param.isShowNameSpeakers, isShowNameSpeakers = _isShowNameSpeakers === void 0 ? true : _isShowNameSpeakers;
    var pathname = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)().pathname;
    var speakersName = speakers.map(function(speaker) {
        return speaker.name;
    }).join(", ");
    var startDateObj = dayjs__WEBPACK_IMPORTED_MODULE_2___default()(startDate);
    var endDateObj = dayjs__WEBPACK_IMPORTED_MODULE_2___default()(endDate);
    var eventDate = {
        day: startDateObj.format("D"),
        month: startDateObj.format("MMM"),
        time: "".concat(startDateObj.tz("Asia/Jakarta").format("HH:mm"), " - ").concat(endDateObj.tz("Asia/Jakarta").format("HH:mm"), " WIB")
    };
    var AvatarProfile = function(param) {
        var name = param.name, image = param.image, index = param.index;
        if (image) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                style: {
                    transform: "translate(-".concat((index + 1) * 3, "px, 3px)")
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: (0,app_PelatihanMandiriPage_helper__WEBPACK_IMPORTED_MODULE_9__/* .cacheImage */ .qM)(image),
                    alt: name,
                    className: "rounded-full bg-transparent h-9 w-9"
                })
            });
        }
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_wartek_id_avatar__WEBPACK_IMPORTED_MODULE_11__/* .Avatar */ .q, {
            name: name,
            alt: name,
            src: "",
            style: {
                transform: "translate(-".concat((index + 1) * 3, "px,0)")
            }
        }, index);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        "data-testid": "webinar",
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)("relative rounded border border-subdued bg-white p-3", active && "border-primary bg-blue-20"),
        children: [
            !!topicName && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_wartek_id_text__WEBPACK_IMPORTED_MODULE_13__/* .Text */ .x, {
                variant: "eyebrow-sm",
                color: "subdued",
                children: topicName
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Anchor__WEBPACK_IMPORTED_MODULE_8__/* .Anchor */ .e, {
                href: href,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                    onClick: function() {
                        (0,utils_googleAnalytics__WEBPACK_IMPORTED_MODULE_7__/* .GATrackEvent */ .l)({
                            eventName: "learning_activity",
                            eventParams: {
                                event_trigger: "webinar_list",
                                action_type: pathname === "/".concat(process.env.NEXT_PUBLIC_TEMP_PELATIHAN_MANDIRI_PATH || "pelatihan-mandiri", "/webinar") ? "click_webinar_from_list" : "click_webinar_from_topic",
                                meta: JSON.stringify({
                                    id: id,
                                    title: title,
                                    topik: topicName,
                                    topik_id: topicId
                                })
                            },
                            sendDefaultParams: true
                        });
                    },
                    className: "overlay-link mb-2 block leading-none",
                    href: href,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_wartek_id_text__WEBPACK_IMPORTED_MODULE_13__/* .Text */ .x, {
                        as: "span",
                        variant: "heading-sm",
                        children: title
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "mb-3",
                children: isShowNameSpeakers && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_wartek_id_text__WEBPACK_IMPORTED_MODULE_13__/* .Text */ .x, {
                    as: "div",
                    variant: "helper",
                    color: "subdued",
                    className: "leading-none",
                    children: speakersName
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex flex-wrap items-center",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex w-1/2 flex-shrink-0 items-center",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "z-10 flex h-9 w-9 items-center justify-center rounded-full border bg-white",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "py-1",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_wartek_id_text__WEBPACK_IMPORTED_MODULE_13__/* .Text */ .x, {
                                            as: "div",
                                            variant: "body-sm",
                                            className: "text-center leading-none",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                                children: eventDate.day
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "-mt-1 text-[8px] font-semibold uppercase",
                                            children: eventDate.month
                                        })
                                    ]
                                })
                            }),
                            speakers.map(function(param, index) {
                                var name = param.name, avatar = param.avatar;
                                return index < 3 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AvatarProfile, {
                                    name: name,
                                    image: avatar,
                                    index: index
                                }) : null;
                            }),
                            speakers.length > 3 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "z-0 flex h-9 w-9 items-center justify-center rounded-full border bg-gray-20",
                                style: {
                                    transform: "translate(-15px,0)"
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_wartek_id_text__WEBPACK_IMPORTED_MODULE_13__/* .Text */ .x, {
                                    variant: "body-sm",
                                    className: "text-subdued",
                                    children: [
                                        "+",
                                        speakers.length - 3
                                    ]
                                })
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "w-1/2 flex-shrink-0 flex-grow-0 text-right",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_wartek_id_text__WEBPACK_IMPORTED_MODULE_13__/* .Text */ .x, {
                            variant: "body-sm",
                            color: "subdued",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "font-semibold",
                                children: eventDate.time
                            })
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (WebinarCard);


/***/ }),

/***/ 83682:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ getWebinarTopicData; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(29815);


var getWebinarTopicData = function(originalTopicData, topicIds, webinarModules) {
    if (!!originalTopicData.topikId && !!originalTopicData.topikTitle) {
        return {
            topikTitle: originalTopicData.topikTitle,
            topikId: originalTopicData.topikId
        };
    }
    var topicData = webinarModules.reduce(function(topicData, module) {
        if (topicIds.includes(module.topikId)) {
            return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(topicData).concat([
                {
                    topikTitle: module.topikTitle,
                    topikId: module.topikId
                }, 
            ]);
        }
        return topicData;
    }, []);
    /** Return null if user has more than topic title (user is multi-jenjang) */ if (topicData.length > 1) return null;
    var _topicData = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(topicData, 1), topicDatum = _topicData[0];
    return topicDatum;
};


/***/ }),

/***/ 55231:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ Anchor; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var utils_androidHandler__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(84494);






var Anchor = function(props) {
    var href = props.href, children = props.children, linkProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(props, [
        "href",
        "children"
    ]);
    var androidHandler = (0,utils_androidHandler__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)();
    var isAndroid = androidHandler.enabled;
    if (isAndroid) {
        // if children tag is anchor tag, return it
        if (children && typeof children === "object") {
            var child = children;
            if (child.type === "a") {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: children
                });
            }
        }
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            href: href
        }, linkProps), {
            children: children
        }));
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        href: href
    }, linkProps), {
        children: children
    }));
};


/***/ }),

/***/ 72351:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S_": function() { return /* binding */ DesktopLayout; },
/* harmony export */   "nc": function() { return /* binding */ WithLayoutListener; }
/* harmony export */ });
/* unused harmony exports useDesktopSubmenuHook, WithDesktopLayout */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70655);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _wartek_id_header_bar__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(89140);
/* harmony import */ var _wartek_id_icon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(21958);
/* harmony import */ var _wartek_id_text__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(89004);








var PELATIHAN_MANDIRI_PATH = "/pelatihan-mandiri";
var SUB_MENU_TEMPLATE = {
    FOR_YOU: next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
        return Promise.all(/* import() */[__webpack_require__.e(2627), __webpack_require__.e(1547), __webpack_require__.e(7882), __webpack_require__.e(8085), __webpack_require__.e(6315), __webpack_require__.e(9514)]).then(__webpack_require__.bind(__webpack_require__, 86315));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(86315)
                ];
            }
        },
        ssr: false
    }),
    TOPIK: next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
        return Promise.all(/* import() */[__webpack_require__.e(5370), __webpack_require__.e(2627), __webpack_require__.e(4088), __webpack_require__.e(7882), __webpack_require__.e(8085), __webpack_require__.e(5888)]).then(__webpack_require__.bind(__webpack_require__, 92629));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(92629)
                ];
            }
        },
        ssr: false
    }),
    AKSI_NYATA: next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
        return Promise.all(/* import() */[__webpack_require__.e(2627), __webpack_require__.e(74), __webpack_require__.e(7882), __webpack_require__.e(9103), __webpack_require__.e(1317)]).then(__webpack_require__.bind(__webpack_require__, 69103)).then(function(template) {
            return template.AksiNyataList;
        });
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(69103)
                ];
            }
        },
        ssr: false
    }),
    MODUL: next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
        return Promise.all(/* import() */[__webpack_require__.e(5370), __webpack_require__.e(6721), __webpack_require__.e(6426), __webpack_require__.e(1855)]).then(__webpack_require__.bind(__webpack_require__, 17422));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(17422)
                ];
            }
        },
        ssr: false
    })
};
var DesktopLayout = function(param) {
    var children = param.children, submenu = param.submenu;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var pathname = router.pathname, query = router.query;
    // TODO: adjust this
    var sideMenu = [
        {
            label: "Seri Pelatihan",
            icon: "book",
            href: "/pelatihan-mandiri",
            active: pathname === "/pelatihan-mandiri" || pathname.includes("/pelatihan-mandiri/seri-pelatihan") || query.from === "learning-series"
        },
        {
            label: "Topik",
            icon: "topic",
            href: "/pelatihan-mandiri/daftar-topik",
            active: pathname === "/pelatihan-mandiri/daftar-topik" || pathname === "".concat(PELATIHAN_MANDIRI_PATH, "/modul/[modul]") || pathname === "".concat(PELATIHAN_MANDIRI_PATH, "/text/[id]") || pathname === "".concat(PELATIHAN_MANDIRI_PATH, "/video/[id]") || pathname === "".concat(PELATIHAN_MANDIRI_PATH, "/quiz/[id]") || pathname === "".concat(PELATIHAN_MANDIRI_PATH, "/refleksi/[id]") || pathname.includes("/pelatihan-mandiri/topik/[topik]") && query.from !== "learning-series"
        },
        {
            label: "Webinar",
            icon: "live_tv",
            href: "/pelatihan-mandiri/webinar",
            active: pathname.includes("/pelatihan-mandiri/webinar")
        },
        {
            label: "Aksi nyata",
            icon: "batch_prediction",
            href: "/pelatihan-mandiri/daftar-aksi-nyata",
            active: pathname === "/pelatihan-mandiri/daftar-aksi-nyata" || pathname.includes("/pelatihan-mandiri/aksi-nyata")
        }, 
    ];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex flex-col h-screen w-full",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "fixed w-full p-4 flex flex-row items-center bg-white z-20",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_wartek_id_header_bar__WEBPACK_IMPORTED_MODULE_3__/* .HeaderBarLeftAction */ .l8, {
                        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_wartek_id_icon__WEBPACK_IMPORTED_MODULE_4__/* .Icon */ .J, {
                            as: "i",
                            color: "default",
                            children: "arrow_back"
                        }),
                        onClick: /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        return [
                                            4,
                                            router.push("/home")
                                        ];
                                    case 1:
                                        _state.sent();
                                        return [
                                            2
                                        ];
                                }
                            });
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_wartek_id_header_bar__WEBPACK_IMPORTED_MODULE_3__/* .HeaderBarTitle */ .rF, {
                        children: "Merdeka Mengajar"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex flex-row bg-gray-10 overflow-hidden h-full",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex flex-col w-64 border-r border-gray-200 mt-[80px] px-4",
                        children: sideMenu.map(function(item, index) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex flex-row items-center p-2 mt-4 rounded-lg cursor-pointer hover:bg-gray-5 ".concat(item.active ? "bg-gray-20" : ""),
                                onClick: /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                return [
                                                    4,
                                                    router.push(item.href)
                                                ];
                                            case 1:
                                                _state.sent();
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                }),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_wartek_id_icon__WEBPACK_IMPORTED_MODULE_4__/* .Icon */ .J, {
                                        as: "i",
                                        color: item.active ? "informational" : "default",
                                        className: "mr-4",
                                        children: item.icon
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_wartek_id_text__WEBPACK_IMPORTED_MODULE_7__/* .Text */ .x, {
                                        color: item.active ? "primary" : "default",
                                        variant: "heading-sm",
                                        children: item.label
                                    })
                                ]
                            }, "sidemenu-".concat(index));
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "overflow-y-scroll w-[380px]",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("main", {
                            className: "mt-8",
                            children: submenu
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex-1 overflow-y-scroll p-2 max-w-6xl mx-auto md:px-8 lg:px-16",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("main", {
                            className: "mt-[80px]",
                            children: children && children
                        })
                    })
                ]
            })
        ]
    });
};
var useDesktopSubmenuHook = function(isDesktop) {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var pathname = router.pathname;
    var _query = router.query, id = _query.id, from = _query.from, menuId = _query.menuId, topik = _query.topik;
    if (!isDesktop) return null;
    var SubMenuPageMap = [
        {
            path: "".concat(PELATIHAN_MANDIRI_PATH, "/seri-pelatihan/[id]"),
            components: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SUB_MENU_TEMPLATE.FOR_YOU, {
                    isDesktop: true,
                    currentId: id
                })
            }, "seri-pelatihan-dekstop-submenu")
        },
        {
            path: "".concat(PELATIHAN_MANDIRI_PATH, "/topik/[topik]"),
            components: menuId && from === "learning-series" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SUB_MENU_TEMPLATE.FOR_YOU, {
                    isDesktop: true,
                    currentId: menuId
                })
            }, "topik-desktop-submenu") : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SUB_MENU_TEMPLATE.TOPIK, {
                    isDesktop: true,
                    currentId: topik
                })
            }, "topik-desktop-submenu")
        },
        {
            path: "".concat(PELATIHAN_MANDIRI_PATH, "/daftar-aksi-nyata"),
            components: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SUB_MENU_TEMPLATE.AKSI_NYATA, {
                    isDesktop: true
                })
            }, "daftar-aksi-nyata-desktop-submenu")
        },
        {
            path: "".concat(PELATIHAN_MANDIRI_PATH, "/aksi-nyata/[id]"),
            components: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SUB_MENU_TEMPLATE.AKSI_NYATA, {
                    isDesktop: true
                })
            }, "aksi-nyata-desktop-submenu")
        },
        {
            path: [
                "".concat(PELATIHAN_MANDIRI_PATH, "/modul/[modul]"),
                "".concat(PELATIHAN_MANDIRI_PATH, "/text/[id]"),
                "".concat(PELATIHAN_MANDIRI_PATH, "/video/[id]"),
                "".concat(PELATIHAN_MANDIRI_PATH, "/quiz/[id]"),
                "".concat(PELATIHAN_MANDIRI_PATH, "/refleksi/[id]"), 
            ],
            components: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SUB_MENU_TEMPLATE.MODUL, {})
            }, "modul-desktop-submenu")
        }, 
    ];
    var currentSubMenu = SubMenuPageMap.map(function(subMenu) {
        if (typeof subMenu.path === "string") {
            if (pathname.includes(subMenu.path)) {
                return subMenu.components;
            }
        }
        if (Array.isArray(subMenu.path)) {
            if (subMenu.path.some(function(path) {
                return pathname.includes(path);
            })) {
                return subMenu.components;
            }
        }
    });
    return currentSubMenu;
};
var WithDesktopLayout = function(param) {
    var children = param.children;
    var currentSubMenu = useDesktopSubmenuHook(true);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DesktopLayout, {
        submenu: currentSubMenu,
        children: children
    });
};
var WithLayoutListener = function(param) {
    var children = param.children, isDesktop = param.isDesktop;
    if (isDesktop) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(WithDesktopLayout, {
            children: children
        });
    }
    return children;
};


/***/ }),

/***/ 52165:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "WU": function() { return /* reexport */ format; },
  "z2": function() { return /* reexport */ register; }
});

// UNUSED EXPORTS: cancel, render

;// CONCATENATED MODULE: ./node_modules/timeago.js/esm/lang/en_US.js
var EN_US = ['second', 'minute', 'hour', 'day', 'week', 'month', 'year'];
/* harmony default export */ function en_US(diff, idx) {
    if (idx === 0)
        return ['just now', 'right now'];
    var unit = EN_US[Math.floor(idx / 2)];
    if (diff > 1)
        unit += 's';
    return [diff + " " + unit + " ago", "in " + diff + " " + unit];
}
//# sourceMappingURL=en_US.js.map
;// CONCATENATED MODULE: ./node_modules/timeago.js/esm/lang/zh_CN.js
var ZH_CN = ['秒', '分钟', '小时', '天', '周', '个月', '年'];
/* harmony default export */ function zh_CN(diff, idx) {
    if (idx === 0)
        return ['刚刚', '片刻后'];
    var unit = ZH_CN[~~(idx / 2)];
    return [diff + " " + unit + "\u524D", diff + " " + unit + "\u540E"];
}
//# sourceMappingURL=zh_CN.js.map
;// CONCATENATED MODULE: ./node_modules/timeago.js/esm/register.js
/**
 * Created by hustcc on 18/5/20.
 * Contract: i@hust.cc
 */
/**
 * All supported locales
 */
var Locales = {};
/**
 * register a locale
 * @param locale
 * @param func
 */
var register = function (locale, func) {
    Locales[locale] = func;
};
/**
 * get a locale, default is en_US
 * @param locale
 * @returns {*}
 */
var register_getLocale = function (locale) {
    return Locales[locale] || Locales['en_US'];
};
//# sourceMappingURL=register.js.map
;// CONCATENATED MODULE: ./node_modules/timeago.js/esm/utils/date.js
/**
 * Created by hustcc on 18/5/20.
 * Contract: i@hust.cc
 */
var SEC_ARRAY = [
    60,
    60,
    24,
    7,
    365 / 7 / 12,
    12,
];
/**
 * format Date / string / timestamp to timestamp
 * @param input
 * @returns {*}
 */
function toDate(input) {
    if (input instanceof Date)
        return input;
    // @ts-ignore
    if (!isNaN(input) || /^\d+$/.test(input))
        return new Date(parseInt(input));
    input = (input || '')
        // @ts-ignore
        .trim()
        .replace(/\.\d+/, '') // remove milliseconds
        .replace(/-/, '/')
        .replace(/-/, '/')
        .replace(/(\d)T(\d)/, '$1 $2')
        .replace(/Z/, ' UTC') // 2017-2-5T3:57:52Z -> 2017-2-5 3:57:52UTC
        .replace(/([+-]\d\d):?(\d\d)/, ' $1$2'); // -04:00 -> -0400
    return new Date(input);
}
/**
 * format the diff second to *** time ago, with setting locale
 * @param diff
 * @param localeFunc
 * @returns
 */
function date_formatDiff(diff, localeFunc) {
    /**
     * if locale is not exist, use defaultLocale.
     * if defaultLocale is not exist, use build-in `en`.
     * be sure of no error when locale is not exist.
     *
     * If `time in`, then 1
     * If `time ago`, then 0
     */
    var agoIn = diff < 0 ? 1 : 0;
    /**
     * Get absolute value of number (|diff| is non-negative) value of x
     * |diff| = diff if diff is positive
     * |diff| = -diff if diff is negative
     * |0| = 0
     */
    diff = Math.abs(diff);
    /**
     * Time in seconds
     */
    var totalSec = diff;
    /**
     * Unit of time
     */
    var idx = 0;
    for (; diff >= SEC_ARRAY[idx] && idx < SEC_ARRAY.length; idx++) {
        diff /= SEC_ARRAY[idx];
    }
    /**
     * Math.floor() is alternative of ~~
     *
     * The differences and bugs:
     * Math.floor(3.7) -> 4 but ~~3.7 -> 3
     * Math.floor(1559125440000.6) -> 1559125440000 but ~~1559125440000.6 -> 52311552
     *
     * More information about the performance of algebraic:
     * https://www.youtube.com/watch?v=65-RbBwZQdU
     */
    diff = Math.floor(diff);
    idx *= 2;
    if (diff > (idx === 0 ? 9 : 1))
        idx += 1;
    return localeFunc(diff, idx, totalSec)[agoIn].replace('%s', diff.toString());
}
/**
 * calculate the diff second between date to be formatted an now date.
 * @param date
 * @param relativeDate
 * @returns {number}
 */
function date_diffSec(date, relativeDate) {
    var relDate = relativeDate ? toDate(relativeDate) : new Date();
    return (+relDate - +toDate(date)) / 1000;
}
/**
 * nextInterval: calculate the next interval time.
 * - diff: the diff sec between now and date to be formatted.
 *
 * What's the meaning?
 * diff = 61 then return 59
 * diff = 3601 (an hour + 1 second), then return 3599
 * make the interval with high performance.
 **/
function date_nextInterval(diff) {
    var rst = 1, i = 0, d = Math.abs(diff);
    for (; diff >= SEC_ARRAY[i] && i < SEC_ARRAY.length; i++) {
        diff /= SEC_ARRAY[i];
        rst *= SEC_ARRAY[i];
    }
    d = d % rst;
    d = d ? rst - d : rst;
    return Math.ceil(d);
}
//# sourceMappingURL=date.js.map
;// CONCATENATED MODULE: ./node_modules/timeago.js/esm/format.js


/**
 * format a TDate into string
 * @param date
 * @param locale
 * @param opts
 */
var format = function (date, locale, opts) {
    // diff seconds
    var sec = date_diffSec(date, opts && opts.relativeDate);
    // format it with locale
    return date_formatDiff(sec, register_getLocale(locale));
};
//# sourceMappingURL=format.js.map
;// CONCATENATED MODULE: ./node_modules/timeago.js/esm/realtime.js



// all realtime timer
var TIMER_POOL = {};
/**
 * clear a timer from pool
 * @param tid
 */
var clear = function (tid) {
    clearTimeout(tid);
    delete TIMER_POOL[tid];
};
// run with timer(setTimeout)
function run(node, date, localeFunc, opts) {
    // clear the node's exist timer
    clear(getTimerId(node));
    var relativeDate = opts.relativeDate, minInterval = opts.minInterval;
    // get diff seconds
    var diff = diffSec(date, relativeDate);
    // render
    node.innerText = formatDiff(diff, localeFunc);
    var tid = setTimeout(function () {
        run(node, date, localeFunc, opts);
    }, Math.min(Math.max(nextInterval(diff), minInterval || 1) * 1000, 0x7fffffff));
    // there is no need to save node in object. Just save the key
    TIMER_POOL[tid] = 0;
    setTimerId(node, tid);
}
/**
 * cancel a timer or all timers
 * @param node - node hosting the time string
 */
function cancel(node) {
    // cancel one
    if (node)
        clear(getTimerId(node));
    // cancel all
    // @ts-ignore
    else
        Object.keys(TIMER_POOL).forEach(clear);
}
/**
 * render a dom realtime
 * @param nodes
 * @param locale
 * @param opts
 */
function render(nodes, locale, opts) {
    // by .length
    // @ts-ignore
    var nodeList = nodes.length ? nodes : [nodes];
    nodeList.forEach(function (node) {
        run(node, getDateAttribute(node), getLocale(locale), opts || {});
    });
    return nodeList;
}
//# sourceMappingURL=realtime.js.map
;// CONCATENATED MODULE: ./node_modules/timeago.js/esm/index.js
/**
 * Created by hustcc on 18/5/20.
 * Contract: i@hust.cc
 */



register('en_US', en_US);
register('zh_CN', zh_CN);



//# sourceMappingURL=index.js.map

/***/ })

}]);